import React, { useContext } from 'react';

const LoadingContext = React.createContext();
export const LoadingProvider = LoadingContext.Provider;
export const LoadingConsumer = LoadingContext.Consumer;

export const withLoading = (Component) => {
  return (props) => (
    <LoadingConsumer>
      {({ loading, setLoading }) => (
        <Component
          loading={loading}
          setLoading={setLoading}
          {...props}
        />
      )}
    </LoadingConsumer>
  );
};

export const useLoading = () => useContext(LoadingContext);

export default LoadingContext;
